import { Avatar as MuiAvatar, Box, Typography } from '@mui/material';

import { useFeature } from '@growthbook/growthbook-react';
import { UserAvatarMenu } from './modules/UserAvatarMenu';
import { HeaderItems } from './HeaderItems';

import { withShowable } from '../../../_global/lib/withShowable';
import { TeamsMenu } from '../../../../teams/TeamsMenu';
import { useAgencyLogo } from './modules/useAgencyLogo';
import LanguageSelector from './modules/LanguageSelector';
import { Show } from '../../../../components/Show';
import { useActor } from '../../../../components/hooks/useActor';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';
import { REDACTED_FIELD } from '../../../../config/logrocket';

interface Props {
  account: any;
}

const Avatar = withShowable(MuiAvatar);

const AgencyMainHeader = ({ account }: Props) => {
  const languageSelectorFeature = useFeature(
    FEATURE_FLAG_KEYS.LANGUAGE_SELECTOR
  );
  const actor = useActor();

  const logoSrc = useAgencyLogo(account.id);

  return (
    <HeaderItems>
      <Box>
        <TeamsMenu />
      </Box>

      <Box className="align-center">
        <Avatar
          variant="rounded"
          src={logoSrc}
          style={{ width: 25, height: 25, marginRight: 8 }}
        />
        <Typography className={`${REDACTED_FIELD} tertia-text`}>
          {account.fullName}
        </Typography>
      </Box>

      <Box>
        <UserAvatarMenu />
      </Box>

      <Show when={languageSelectorFeature.on && actor.isCowbell}>
        <LanguageSelector />
      </Show>
    </HeaderItems>
  );
};

export default withShowable(AgencyMainHeader);
